/**
 * @module views\sys\db\templates\dynamicProperty\selectionPropertys
 */
import Vue from "vue";
import Component from "vue-class-component";
import BaseEditor from "../../base";

@Component
export default class SelectionPropertys extends BaseEditor {
  private keys = [
    "valueColumn",
    "textColumn",
    "sourceItemValue",
    "sourceItemText",
    "multiple"
  ];

  private get Props() {
    return this.getProps(this.keys);
  }
}
